import ListingBadge, { BADGE_MODE, BADGE_ORDER_PRIORITY } from './base';
import { isForeclosure } from './utils';
class NewlyListedBadge extends ListingBadge {
    static title = 'Newly Listed';
    static summary = '';
    static titleIcon = 'certificate';
    static titleV2 = 'New';
    static renderPriorityV2 = listing => isForeclosure(listing)
        ? BADGE_ORDER_PRIORITY.FIFTH
        : BADGE_ORDER_PRIORITY.THIRD;
    static content = null;
    static renderPriority = BADGE_ORDER_PRIORITY.FIRST;
    static shouldBeIncluded(listing, badgeMode) {
        return ((badgeMode === BADGE_MODE.CONDENSED || badgeMode === BADGE_MODE.V2) &&
            listing.primary_property?.is_newly_listed);
    }
    static shouldBeIncludedV2 = this.shouldBeIncluded;
}
export default NewlyListedBadge;
//# sourceMappingURL=newlyListed.js.map